import React from "react";
import { useParams } from "react-router-dom";
import LoginFooter from "../../components/login/LoginFooter";
import PublicPageShell from "../../components/publicPages/PublicPageShell";
import { useBranding } from "../../hooks/useBranding";
import { usePublicConfigValue } from "../../hooks/usePublicConfig";
import { usePublicPageContent } from "../../hooks/usePublicPageContent";

const FALLBACK_PAGES = {
  about: {
    title: "About Uniflo",
    content:
      "<h2>About Uniflo</h2><p>Uniflo brings communities together with collaboration tools, events, messaging, and shared digital workspaces.</p>",
  },
};

export default function SitePage() {
  const { slug = "" } = useParams();
  const normalizedSlug = `${slug || ""}`.trim().toLowerCase();
  const { siteName, logoUrl } = useBranding();
  const publicConfig = usePublicConfigValue();
  const { data: page, isLoading, error } = usePublicPageContent(normalizedSlug);
  const resolvedPage = page || FALLBACK_PAGES[normalizedSlug] || null;

  if (!isLoading && !resolvedPage) {
    return (
      <PublicPageShell
        publicPages={publicConfig?.publicPages || {}}
        pageKey="content"
        logoUrl={logoUrl}
        siteName={siteName}
        eyebrow="Public Page"
        fallbackTitle="Page not found"
        fallbackSubtitle="The public page you requested could not be found."
        page={{
          title: "Page not found",
          content: `<p>${
            error?.response?.data?.message || "The requested page could not be found."
          }</p>`,
        }}
        footer={<LoginFooter />}
      />
    );
  }

  return (
    <PublicPageShell
      publicPages={publicConfig?.publicPages || {}}
      pageKey="content"
      logoUrl={logoUrl}
      siteName={siteName}
      eyebrow="Public Page"
      fallbackTitle={resolvedPage?.title || "Page"}
      fallbackSubtitle=""
      page={resolvedPage}
      footer={<LoginFooter />}
    />
  );
}
